module.exports = __webpack_public_path__ + "media/images/pocstock-subscription-ad-e826606ed38f2b9f5c2480958cde21d7.png";